import { branch, compose, renderNothing, withProps, withState } from 'recompose'
import { connect } from 'react-redux'
import { forceHistory } from 'src/composables'
import { selectRouteKey } from 'src/store/selectors/layout'
import {
  selectCustomerProfile,
  selectOfficeProfile,
  selectCorporateProfile,
  selectOfficeZip,
  selectCustomerNMLS
} from 'src/store/selectors/customerProfile'

const getPropsFromRecords = ({
  officeProfile: office,
  corporateProfile: corp
}) => {
  const { address } = office

  return {
    corporateName: corp.name,
    logo: corp.logoDarkUri,
    officeName: office.name,
    showAddress: corp.showAddress,
    city: address.city,
    state: address.state,
    street: address.street
  }
}

const AgentDropdownContainer = compose(
  forceHistory,
  withProps(() => ({
    isHomeowner: selectRouteKey() === 'home'
  })),
  connect(state => ({
    customerProfile: selectCustomerProfile(state),
    officeProfile: selectOfficeProfile(state),
    corporateProfile: selectCorporateProfile(state),
    zip: selectOfficeZip(state),
    nmls: selectCustomerNMLS(state)
  })),
  branch(
    ({ customerProfile, officeProfile, isHomeowner }) =>
      !(customerProfile && officeProfile && isHomeowner),
    renderNothing
  ),
  withProps(getPropsFromRecords),
  withState('open', 'setOpen', false)
)

export default AgentDropdownContainer
